export const ElectronicForms = (destinationLang) => {
  return [
    {
      FormKey: 'electronic-forms-button-edit-picture',
      Key: 'ویرایش عکس',
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: 'electronic-forms-alert-ask-confirm',
      Key: 'آيا از تایید فرم اطمینان دارید؟',
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: 'electronic-forms-alert-ask-unconfirm',
      Key: 'آيا از لغو تایید فرم اطمینان دارید؟',
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: 'electronic-forms-edit-form-title-navbar',
      Key: 'ویرایش فرم',
      DistinitationLanguage: destinationLang,
    },
  ];
};
